import { render } from "./ResultatsEffetsSurface.vue?vue&type=template&id=6d0792a6"
import script from "./ResultatsEffetsSurface.vue?vue&type=script&lang=js"
export * from "./ResultatsEffetsSurface.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__